import { supabase } from '@/lib/supabase';

export type OrgUsageBreakdown = {
  total: number;
  by_status?: Record<string, number>;
};

export type OrgUsage = {
  users: OrgUsageBreakdown;
  contacts: OrgUsageBreakdown;
  events: OrgUsageBreakdown;
  event_categories: OrgUsageBreakdown;
  services: OrgUsageBreakdown;
  crm_products: OrgUsageBreakdown;
  courses: OrgUsageBreakdown;
  purchased_products: OrgUsageBreakdown;
};

export const adminApi = {
  getOrgUsage: async (orgId: string): Promise<OrgUsage> => {
    const { data, error } = await supabase.rpc('admin_org_usage', { p_org_id: orgId });
    if (error) throw error;
    return data as OrgUsage;
  },
};
